import { render } from "./AnimatedElement.vue?vue&type=template&id=845d98dc"
import script from "./AnimatedElement.vue?vue&type=script&lang=js"
export * from "./AnimatedElement.vue?vue&type=script&lang=js"

import "./AnimatedElement.vue?vue&type=style&index=0&id=845d98dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__